import { useQuery } from '@tanstack/react-query'

import type {
  ApiError,
  ExtensionComparisonRequest,
  ExtensionComparisonResponse,
} from '@mangovoice/types'

import { useReportingApi } from '../api/context'
import { REPORTING_QUERY_KEYS } from '../api/endpoints'

interface UseGetExtensionComparisonParams {
  request?: ExtensionComparisonRequest
  enabled?: boolean
}

export const useGetExtensionComparison = ({
  request,
  enabled = true,
}: UseGetExtensionComparisonParams) => {
  const api = useReportingApi()

  return useQuery<ExtensionComparisonResponse, ApiError>({
    queryKey: [REPORTING_QUERY_KEYS.extensionComparison, request],
    queryFn: async ({ signal }) => {
      if (!request) throw new Error('Request is required')

      const { ok, data } = await api.getExtensionComparison(request, signal)

      if (!ok) {
        return Promise.reject(
          (data as ApiError) ??
            new Error('Extension comparison request failed'),
        )
      }

      if (!data) {
        return Promise.reject(
          new Error('No data returned from extension comparison API'),
        )
      }

      return data
    },
    enabled: enabled && !!request,
    retry: false,
  })
}
